import React from "react";
import { RootState } from "redux/store";
import { Dispatch, bindActionCreators } from "redux";
import { connect } from "react-redux";import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { styles } from "../../style";
import { Dialog } from "component/shared/dialog";
import { CustomAutocomplete } from "component/shared/auto-complete";
import { LeadPipelineType } from "type/lead-pipeline";
import { createLeadPipeline } from "redux/slice/lead-pipelines";
import * as yup from "yup";
import { validate } from "shared/yup";
import * as env from "shared/env";

const mapStateToProps = (state: RootState) => {
	return {
	};
};

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
	createLeadPipeline
}, dispatch);

interface Props extends 
	ReturnType<typeof mapStateToProps>,
	ReturnType<typeof mapDispatchToProps>,
	WithStyles<typeof styles> {
	onClose: Function,
	leadIds: number[],
}

interface State {
	pipelineId?: number;
	input: string;
	submitted: boolean;
}

class Component extends React.Component<Props, State> {

	public constructor(props: Props) {
		super(props);
		this.state = {
			pipelineId: undefined,
			input: "",
			submitted: false,
		};
	}

	private validationSchema = {
		pipelineId: yup
			.string()
			.required("Please select a stage."),
	};

	private updateStage() {
		const { leadIds, createLeadPipeline } = this.props;
		const { pipelineId } = this.state;

		const errors = validate(this.validationSchema, this.state);

		if (!errors && pipelineId) {
			leadIds.forEach((id) => {
				const leadPipeline = {
					leadId: id,
					type: LeadPipelineType.getByIdOrDefault(pipelineId),
				}
				createLeadPipeline({leadPipeline});
			});
			this.onClose();
		} else {
			this.setState({ submitted: true });
		}
	}

	private onClose() {
		this.props.onClose();
		this.setState({ pipelineId: undefined, input: "", submitted: false });
	}

	render() {
		const { classes = {} } = this.props;
		const { pipelineId, input, submitted } = this.state;
		const errors = validate(this.validationSchema, this.state);
		const pipelineOptions = LeadPipelineType.values()
			.filter(
				(stage: any) =>
					stage && typeof stage === "object" && "id" in stage && "label" in stage
			)
			.map((stage: any) => ({
				value: stage.id,
				label: stage.label,
			}));
		
		return (
			<Dialog
				open={true}
				onClose={() => this.onClose()}
				fullWidth={true}
				maxWidth="xs" 
			>
				<Mui.DialogTitle>Update Pipeline Stage</Mui.DialogTitle>
				<Mui.DialogContent dividers className={classes.dialogContent}>
					<Mui.Grid container alignItems="center" justifyContent="center" spacing={1}>
						<Mui.Grid item xs={12}>
							<Mui.DialogContentText className={classes.dialogText}>Select a Pipeline Stage to be applied to all selected records.</Mui.DialogContentText>
						</Mui.Grid>
						<Mui.Grid item xs={12}>
							<CustomAutocomplete
								options={pipelineOptions}
								textInputHeight={true}
								label="Select Stage"
								optionLabelExtractor={(option) => option.label}
								fullWidth
								margin="dense"
								placeholder="Select a stage"
								onInputChange={(event, value, reason) => {
									if (reason === "reset") {
										this.setState({ input: "" });
									} else {
										this.setState({ input: value });
									}
								}}
								onChange={(event, option) => {
									if (option && option.value) {
										this.setState({
											pipelineId: option.value as number,
											input: option.label,
										});
									}
								}}
								inputValue={input}
								helperText={submitted && errors && errors.pipelineId ? errors.pipelineId : undefined}
							/>
						</Mui.Grid>
					</Mui.Grid>
				</Mui.DialogContent>
				<Mui.DialogActions className={classes.dialogActions}>
					<Mui.Button 
						onClick={() => this.onClose()} 
						variant="outlined"
						color={"primary"}
					>
						Cancel
					</Mui.Button>
					<Mui.Button
						onClick={() => {
							this.updateStage()
						}}
						variant="contained"
						color={"primary"}
						disabled={submitted && !pipelineId}
					>
						Save
					</Mui.Button>
				</Mui.DialogActions>
			</Dialog>
		)
	}
}

export const BulkPipelineStageDialog = withStyles(connect(mapStateToProps, mapDispatchToProps)(Component), styles);